export interface ChromeTab {
  id?: number;
  url?: string;
  title?: string;
}

export interface ChromeRuntime {
  sendMessage: (message: ChromeMessage) => Promise<ChromeResponse>;
}

export interface ChromeTabs {
  query: (queryInfo: {
    active: boolean;
    currentWindow: boolean;
  }) => Promise<ChromeTab[]>;
}

export interface ChromeAPI {
  runtime: ChromeRuntime;
  tabs: ChromeTabs;
}

export enum ChromeMessageType {
  WHOLE_PAGE = "whole_page",
  VISIBLE_PART = "visible_part",
  CREATE = "create",
  RESIZE = "resize",
  GET_PAGE_INFO = "get_page_info",
  PAGE_INFO = "page_info",
  EXPORT_DOCUMENT = "export_document",
  EXPORT_RESULT = "export_result",
}

export interface ChromeMessage {
  name: ChromeMessageType;
  body?: {
    useDebugger?: boolean;
    clientWidth?: number;
    clientHeight?: number;
    filename?: string;
    uint8arr?: number[];
    type?: string;
  };
}

export interface ChromeResponse {
  dataUrl: ArrayBuffer;
}

declare global {
  interface Window {
    chrome: ChromeAPI;
  }
}

export {};
